<div class="main-wrapper">
  <div class="header-wrapper">
    <label
      [class]="[currentTab == 1 ? 'header-active' : 'header']"
      id="one-tab"
      for="one"
      (click)="selectTab(1)"
      >Project information</label
    >
    <label
      [class]="[currentTab == 2 ? 'header-active' : 'header']"
      id="two-tab"
      for="two"
      (click)="selectTab(2)"
      >User parameters</label
    >
  </div>

  <table class="fault-table" *ngIf="currentTab == 1">
    <colgroup>
      <col span="1" style="width: 100px" />
      <col span="1" style="width: 80%" />
    </colgroup>
    <tr>
      <td>Project name</td>
      <td>{{ projectName }}</td>
    </tr>
    <tr>
      <td>VeriCure by Vortex Version</td>
      <td></td>
    </tr>
    <tr>
      <td>CMS serial number</td>
      <td>{{ this.tempData.SER }}</td>
    </tr>
    <tr>
      <td>Fiber</td>
      <td>{{ this.tempData.FIB }}</td>
    </tr>
    <tr>
      <td>Length</td>
      <td>
        {{ this.tempData.CRE - this.tempData.CRB
        }}<span *ngIf="projectService.isMetricUnit">m</span
        ><span *ngIf="!projectService.isMetricUnit">ft</span>
      </td>
    </tr>
    <tr>
      <td>Curing temperature</td>
      <td>
        {{ this.tempData.CT
        }}<span *ngIf="projectService.isMetricUnit">&deg;C</span
        ><span *ngIf="!projectService.isMetricUnit">&deg;F</span>
      </td>
    </tr>
    <tr>
      <td>Overheat temperature</td>
      <td>
        {{ this.tempData.OT
        }}<span *ngIf="projectService.isMetricUnit">&deg;C</span
        ><span *ngIf="!projectService.isMetricUnit">&deg;F</span>
      </td>
    </tr>
    <tr>
      <td>Measurement information</td>
      <td>{{ this.tempData.MI }}s</td>
    </tr>
    <tr>
      <td>Sampling interval</td>
      <td>
        {{ this.tempData.SI }}<span *ngIf="projectService.isMetricUnit">m</span
        ><span *ngIf="!projectService.isMetricUnit">ft</span>
      </td>
    </tr>
    <tr>
      <td>First measurement</td>
      <td>{{ firstMeasurement | date : "M/d/yy, h:mm:ss a" }}</td>
    </tr>
    <tr>
      <td>Last measurement</td>
      <td>{{ lastMeasurement | date : "M/d/yy, h:mm:ss a" }}</td>
    </tr>
    <tr>
      <td>Traces taken</td>
      <td>{{ this.tempData.TRC.length }}</td>
    </tr>
    <tr>
      <td>Heat input</td>
      <td>
        <ul class="heatmap-temp">
          <li *ngFor="let h of this.tempData.HMC">
            {{ h.HT | number : "1.0-1"
            }}<span *ngIf="projectService.isMetricUnit">&deg;C</span
            ><span *ngIf="!projectService.isMetricUnit">&deg;F</span> for
            {{ h.HM }} min
          </li>
        </ul>
      </td>
    </tr>
  </table>

  <!-- Params =========================================================== -->

  <table class="param-table" *ngIf="currentTab == 2">
    <colgroup>
      <col span="1" style="width: 250px" />
      <col span="1" />
    </colgroup>
    <tr class="row-param" *ngFor="let pp of this.tempData.U">
      <td>{{ pp.UN }}</td>
      <td>{{ pp.UV }}</td>
    </tr>
  </table>
</div>
